import ConfirmationReportsList from "../components/ConfirmationReportsList/ConfirmationReportsList";

export default function ConfirmationReportsPage() {
    return <ConfirmationReportsList />;
}
